// .u_gallery

var $ = jQuery
$(document).ready(function () {
  var $gallery = $('div.u_gallery')
  $gallery.find('.btn-close').on('click', closeGallery)
  $gallery.find('.btn-fullscreen').on('click', toggleFullscreenGallery)

  if (window.location.hash) {
    var slug = window.location.hash.substring(1).replace('/', '')
    $gallery = $('[data-slug="' + slug + '"]').first()
    if ($gallery.length) {
      openGallery($gallery)
    }
  }
})

// $info is required to have data-slug, data-title and data-images attributes.
function openGallery ($info) {
  $('body').addClass('modal-open')

  var $gallery = $('.u_gallery')
  var $slideshow = $gallery.find('.slideshow')
  var $thumbnails = $gallery.find('.thumbs')
  var $totalPhotos = $gallery.find('.total-photos')
  var images = $info.attr('data-images').split(',')

  // open overlay and update title and tags
  $gallery.addClass('isOpen')
  $gallery.find('.gallery-title').html($info.attr('data-title'))
  $totalPhotos.find('.current').html('1')
  $totalPhotos.find('.total').html(images.length)

  // update the slideshow and thumbs content
  if ($slideshow.hasClass('slick-initialized')) { $slideshow.slick('unslick') }
  if ($thumbnails.hasClass('slick-initialized')) { $thumbnails.slick('unslick') }
  $slideshow.empty()
  $thumbnails.empty()
  for (var i in images) {
    $slideshow.append('<div class="slide"><div class="gallery--slide"><div class="container">' +
      '<img class="image" data-lazy="' + images[i] + '">' +
      '</div></div></div>')
    // $thumbnails.append('<div class="thumb"><div class="gallery--thumb" style="background-image: url(\'' + images[i] + '\')">' +
    //   '<img class="image" data-lazy="' + images[i] + '">' +
    //   '</div></div>')
    $thumbnails.append('<div class="thumb"><div class="gallery--thumb">' +
      '<img class="image" data-lazy="' + images[i] + '">' +
      '</div></div>')
  }

  // make the slideshows work
  $slideshow.slick({
    dots: false,
    autoplay: false,
    autoplaySpeed: 5000,
    lazyLoad: 'ondemand',
    // adaptiveHeight: true,
    asNavFor: '.u_gallery .thumbs'
  })
  $thumbnails.slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.u_gallery .slideshow',
    lazyLoad: 'ondemand',
    dots: false,
    centerMode: false,
    focusOnSelect: true
  })
  $slideshow.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $totalPhotos.find('.current').html(nextSlide + 1)
  })
  $thumbnails.on('lazyLoaded', function (event, slick, image, imageSource) {
    $(image).parent().css('background-image', 'url(\'' + imageSource + '\')')
  })
}
function closeGallery () {
  $('.u_gallery').removeClass('isOpen')
  $('body').removeClass('modal-open')
  window.location.hash = ''
}

// https://developers.google.com/web/fundamentals/native-hardware/fullscreen/
function toggleFullscreenGallery () {
  var doc = window.document
  var docEl = doc.documentElement

  var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen
  var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen

  if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
    requestFullScreen.call(docEl)
  } else {
    cancelFullScreen.call(doc)
  }
}
